import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

import { VisitAndAppointmentStatus } from '@dreryk/egabinet-visit-frontend-api';

import { createInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';

import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys } from '../../../../../translations';

import {
   getVisitAndAppointmentStatusesFilterCount,
   getVisitAndAppointmentStatusFilterSearchParamValueFromStatuses,
} from './VisitAndAppointmentStatusField.utils';
import { visitAndAppointmentStatusFilterStorage } from './VisitAndAppointmentStatusField.storage';

export const useVisitAndAppointmentStatusTriggerLabelExtractor = (): ((
   statuses: VisitAndAppointmentStatus[]
) => string) => {
   const translate = useTranslate();
   return (currentStatuses) => {
      if (!currentStatuses.length) {
         return translate(appointmentsTranslationKeys.visitAndAppointmentStatusFilter.selectStatuses);
      }
      return translate(
         createInterpolatedTranslationKey(appointmentsTranslationKeys.visitAndAppointmentStatusFilter.chosenOf, {
            count: currentStatuses.length,
            totalCount: getVisitAndAppointmentStatusesFilterCount(),
         })
      );
   };
};

export const useVisitAndAppointmentStatusFilterSearchParamHandler = (
   currentStatuses: VisitAndAppointmentStatus[]
): VoidFunction => {
   const history = useHistory();
   const location = useLocation();

   return useCallback(() => {
      const searchParams = new URLSearchParams(location.search);
      const statusesFilterValue = getVisitAndAppointmentStatusFilterSearchParamValueFromStatuses(currentStatuses);
      if (currentStatuses.length) {
         searchParams.set(visitPaths.VISIT_AND_APPOINTMENT_STATUS_SEARCH_PARAM, statusesFilterValue);
         visitAndAppointmentStatusFilterStorage.setFilter(statusesFilterValue);
      }

      if (!currentStatuses.length) {
         searchParams.delete(visitPaths.VISIT_AND_APPOINTMENT_STATUS_SEARCH_PARAM);
         visitAndAppointmentStatusFilterStorage.removeFilter();
      }

      history.replace({
         search: searchParams.toString(),
         state: location.state,
      });
   }, [currentStatuses, history, location.search, location.state]);
};
